export default __webpack_public_path__ + "static/media/matt.3800a23a.png";